import { useMemo, type FC } from 'react';
import { PapiGallection } from '@wix/da-papi-types';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import FolderContent from '../FolderContent';
import MobileGallectionHeader from '../MobileGallectionHeader';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import FolderSlider from '../FolderSlider';

import s from './GallectionSimpleView.scss';

export interface Props {
  currentFolder?: PapiGallection;
}

const MobileGallectionSimpleView: FC<Props> = ({ currentFolder }) => {
  const hasNewFolderFeature = useFlag('folders_layout');

  const showSlider = useMemo(() => {
    if (hasNewFolderFeature) {
      if (currentFolder && currentFolder.hasSubfolders) {
        return true;
      }
    }
    return false;
  }, [currentFolder, hasNewFolderFeature]);

  return (
    <div id="content" className={s['root']}>
      <ErrorBoundary debugComponent="MobileGallectionSimpleView">
        <MobileGallectionHeader currentFolder={currentFolder} />
        {showSlider && <FolderSlider />}
        <div id="sub-folder-gallery">
          {currentFolder && (
            <FolderContent
              key={currentFolder?.folderId}
              folderId={currentFolder?.folderId || 0}
            />
          )}
        </div>
      </ErrorBoundary>
    </div>
  );
};

MobileGallectionSimpleView.displayName = 'MobileGallectionSimpleView';
export default MobileGallectionSimpleView;
